import {
  WesterosClassroomType,
  FilterClassroomsByPeriodType,
} from '@/models/enrollments/classroom.model';
import Vue from 'vue';
import { MutationTree } from 'vuex';
import { ClassroomState, ClassroomProgress } from './state';

const mutations: MutationTree<ClassroomState> = {
  SET_CLASSROOM_STUDENT_IDS(state, entities: ClassroomState) {
    if (!entities.classrooms) return;

    const classrooms = Object.values(entities.classrooms);

    classrooms.forEach((classroom) => {
      const { id: classroomId, enrollmentsByClassroomId } = classroom;

      const studentsIds = enrollmentsByClassroomId
        ? enrollmentsByClassroomId.map((enrollment) => enrollment.userId)
        : [];

      Vue.set(state.studentsIds, classroomId.toString(), studentsIds);
    });
  },
  SET_CLASSROOMS(state, entities: ClassroomState) {
    if (!entities.classrooms) return;

    Object.values(entities.classrooms).forEach((classroom) => {
      Vue.set(state.classrooms, classroom.id.toString(), {
        ...state.classrooms[classroom.id],
        ...classroom,
      });
    });
  },
  SET_LOADING_REVISION_LIST(state, payload: { isLoading: boolean; classroomId: number }) {
    const { isLoading, classroomId } = payload;

    Vue.set(state.isLoadingRevisionLists, classroomId, isLoading);
  },
  SET_LOADING_CLASSROOM_MATERIALS(state, payload: { isLoading: boolean; classroomId: number }) {
    const { isLoading, classroomId } = payload;

    Vue.set(state.isLoadingClassroomMaterials, classroomId, isLoading);
  },
  SET_LOADING_CLASSROOM_DATA(state, payload: { isLoading: boolean }) {
    const { isLoading } = payload;

    state.isLoadingClassroomData = isLoading;
  },
  SET_LOADING_CLASSROOM_APPOINTMENTS(state, payload: { isLoading: boolean; classroomId: number }) {
    const { isLoading, classroomId } = payload;

    Vue.set(state.isLoadingClassroomAppointments, classroomId, isLoading);
  },
  SET_CLASSROOMS_PROGRESS(state, classroomsProgresses: ClassroomProgress[]) {
    if (!classroomsProgresses.length) return;

    classroomsProgresses.forEach(({ classroomId, progress }) => {
      Vue.set(state.classroomsProgressMap, classroomId.toString(), { classroomId, progress });
    });
  },
  SET_ALL_CLASSROOMS_BY_PERIOD(state, classrooms) {
    if (!classrooms.length) return;

    state.allClassroomsByPeriod = classrooms;
  },
  SET_CURRENT_CLASSROOMS_BY_PERIOD(state, periodNumber) {
    if (periodNumber == null) return;

    const { allClassroomsByPeriod } = state;

    const classroomsByPeriod = allClassroomsByPeriod.reduce(
      (acc: [WesterosClassroomType[]], classroom: FilterClassroomsByPeriodType) => {
        if (classroom.period === periodNumber) {
          acc.push(classroom.classrooms);
        }

        return acc;
      },
      [],
    );

    state.currentClassroomsByPeriod = classroomsByPeriod.length ? classroomsByPeriod[0] : [];
  },
};

export default mutations;
